import BaseViewModel from '@src/slide/infrastructure/module/independent/view-service-define/base/base-view-model';
import {
    IBaseCanvasProps,
    IBaseCanvasState,
} from '@src/slide/application/service/canvas-component/core/base/type';
import { ICanvasSize } from '@src/slide/application/service/canvas-component/core/base/canvas-size-handler/interface';

export default class BaseCanvasModel<P extends IBaseCanvasProps> extends BaseViewModel<P> implements IBaseCanvasState {
    public disableScrollX: boolean;
    public disableScrollY: boolean;
    public canvasSize?: ICanvasSize;

    public initModel(props?: P, initObj?: Partial<this>) {
        this.disableScrollX = true;
        this.disableScrollY = true;

        const { canvasSize } = initObj || { };
        this.canvasSize = canvasSize;
    }
}
